import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";
import markup from "ulysses/widgets/userview.html";
import "../widgets";

$(document).ready(function () {
    $(markup).appendTo($("body"));
});

function edit_dataview_settings(current_data) {
    var res = Promise.Deferred();
    var cdata = ko.toJS(current_data);
    var dialog = uly.dialogs.execute($("#userview-settings-tmpl").html(), {
            "title": _("userview_title_view_settings", "View Settings")
        }, cdata)
        .done(function ([result]) {
            res.resolve({
                "view_name": ko.unwrap(result.view_name),
                "entity": ko.unwrap(result.entity),
                "path": ko.unwrap(result.path) || null,
                "caption": ko.unwrap(result.caption) || null
            });
        }).fail(res.reject);
    return res.promise();
}

function initialise_dataview() {
    var init_def = Promise.Deferred();
    var data = {
        "view_name": ko.observable("editpanel"),
        "path": ko.observable(null),
        "entity": ko.observable(null),
        "caption": ko.observable(_("userview_initialise_dataview_user_view", "User View"))
    };
    if (uly.page.settings && ko.unwrap(uly.page.page_resource) && ko.unwrap(ko.unwrap(uly.page.page_resource).type_name)) {
        data.entity(ko.unwrap(ko.unwrap(uly.page.page_resource).type_name));
    }
    edit_dataview_settings(data).done(function (result) {
        data.view_name(result.view_name);
        data.path(result.path);
        data.entity(result.entity);
        data.caption(result.caption);
        init_def.resolve(data);
    });
    return init_def;
}

ko.bindingHandlers.masterview = {
    "init": function (elt, va, allbindings, model, context) {
        var widget_model = ko.unwrap(va());
        var settings = ko.unwrap(widget_model.settings);
        widget_model.show_header(false);
        var view_model = {
            "markup": ko.observable(null),
            "data": ko.observable(null),
            "icon": widget_model.icon,
            "title": widget_model.title,
            "colour": ko.observable(null),
            "actions": ko.observableArray([]),
            "breadcrumbs": ko.observableArray(null),
            "subtitle": ko.observable(null)
        };
        view_model.icon("fa-wrench");
        view_model.colour("jacksons-purple");
        var $holder = $(elt).parent();
        $holder.data("masterview_model", view_model);
        var new_context = context.createChildContext(view_model);
        ko.applyBindingsToDescendants(new_context, elt);
        return {
            controlsDescendantBindings: true
        };
    },
    "update": function (elt, va, allbindings, model, context) {
        var sub = $(elt).data("sub_token");
        if (sub) {
            uly.unsubscribeToChange(sub.id, sub.token);
            $(elt).data("sub_token", null);
        }

        var entity = ko.unwrap(uly.page.page_resource);
        if (entity) {
            var hal_entity = HalResource(entity);
            hal_entity.done(function (result) {
                var u_id = entity.unique_id;
                if (u_id) {
                    if (u_id.indexOf("/")) {
                        u_id = u_id.slice(0, u_id.indexOf("/"));
                    }
                    $(elt).data("sub_token", {
                        "token": uly.subscribeToChange(u_id, function () {
                            uly.utils.throttle(elt, function () {
                                uly.page.refresh_resource();
                            }, 500);
                        }, elt),
                        "id": u_id
                    });
                }
                setTimeout(function () {
                    //force async to stop auto-subscriptions.
                    var $holder = $(elt).parent();
                    var model = $holder.data("masterview_model");

                    var markup = ko.unwrap(result).view;
                    var data = ko.mapping.fromJS(ko.unwrap(result).data);
                    var title = ko.unwrap(result.caption);
                    var icon = ko.unwrap(result.icon);
                    var colour = ko.unwrap(result.colour);
                    hal_entity.follow_with_cache("uly:actions", uly.api.action_cache).done(function (actions) {
                        model.actions(actions);
                    });
                    model.breadcrumbs(ko.unwrap(result.breadcrumbs) || null);
                    model.subtitle(ko.unwrap(result.subtitle));
                    model.data(data);
                    model.markup(markup);
                    model.title(title);
                    if (icon) model.icon(icon);
                    if (colour) model.colour(colour);
                    uly.publish("widget.active", elt);
                }, 0);
            });
        }
    }
};
ko.virtualElements.allowedBindings.masterview = true;

ko.bindingHandlers.mastergrid = {
    "init": function (elt, va, allbindings, model, context) {
        var widget_model = ko.unwrap(va());
        var settings = ko.unwrap(widget_model.settings);
        widget_model.show_header(false);
        var view_model = {
            "entity": ko.observable(ko.unwrap(settings.entity)),
            "icon": widget_model.icon,
            "title": widget_model.title,
            "colour": ko.observable(null),
            "actions": ko.observableArray([])
        };
        view_model.icon("fa-wrench");
        view_model.colour("jacksons-purple");
        var $holder = $(elt).parent();
        $holder.data("masterview_model", view_model);
        var new_context = context.createChildContext(view_model);
        ko.applyBindingsToDescendants(new_context, elt);
        return {
            controlsDescendantBindings: true
        };
    },
    "update": function (elt, va, allbindings, model, context) {
        var entity = ko.unwrap(uly.page.page_resource);
        var settings = ko.unwrap(ko.unwrap(va()).settings);
        if (entity) {
            var hal_entity = HalResource(entity);
            hal_entity.done(function (result) {
                var $holder = $(elt).parent();
                var model = $holder.data("masterview_model");
                console.log("got mastergird result:", result);
                //var markup = ko.unwrap(result).view;
                //var data = ko.mapping.fromJS(ko.unwrap(result).data);
                var title = ko.unwrap(result.caption || ko.unwrap(settings.title));
                var icon = ko.unwrap(result.icon);
                var colour = ko.unwrap(result.colour);
                hal_entity.follow_with_cache("uly:actions", uly.api.action_cache).done(function (actions) {
                    model.actions(actions);
                });

                //model.data(data);
                //model.markup(markup);
                model.title(title);
                if (icon) model.icon(icon);
                if (colour) model.colour(colour);
                uly.publish("widget.active", elt);
            });
        }
    }
};
ko.virtualElements.allowedBindings.mastergrid = true;

/* New grid binding for simple grids */
ko.bindingHandlers.grid = {
    init: function (elt, va, allbindings, viewModel, context) {
        console.log("va:", ko.unwrap(va()), "model:", viewModel, "context:", context);
        var grid_model = ko.unwrap(va());
        var entity = ko.unwrap(grid_model.entity);
        uly.api.start().follow("uly:data").follow("uly:" + entity, {
            "nodata": 1
        }).follow("uly:grid", function (result) {
            ko.bindingHandlers.datatable.init(elt, result, allbindings, viewModel, context);
        });
        //ko.bindingHandlers.datatable.init(elt, va, allbindings, viewModel, context);// function() { return { dataparameters:{rel:entity_data.id} }; });
        return {
            "controlsDescendantBindings": true
        }
    },
    update: function (elt, va, allbindings, viewModel, context) {}
};


ko.bindingHandlers.userview = {
    "init": function (elt, va, allbindings, model, context) {
        var widget_model = ko.unwrap(va());
        var settings = ko.unwrap(widget_model.settings);

        var settings_menu = widget_model.settings_menu;
        settings_menu.push({
            "caption": _("userview_caption_modify", "Modify"),
            "icon": "fa-edit",
            "action": function (e) {
                edit_dataview_settings(settings).done(function (result) {
                    settings.view_name(result.view_name);
                    settings.entity(result.entity);
                    settings.path(result.path || null);
                    settings.caption(result.caption || null);
                    uly.publish("page.savesettings");
                });
            },
            "colour": "primary"
        });

        widget_model.title(_("userview_loading", "loading..."));
        widget_model.icon("fa fa-tags");
        widget_model.show_header(true);
        var entity_data = ko.observable(null);
        $(elt).data("widget_data", entity_data);

        return {
            controlsDescendantBindings: true
        };
    },
    "update": function (elt, va, allbindings, model, context) {
        uly.publish("widget.loading", elt);
        var data_obs = $(elt).data("widget_data");
        var widget_model = ko.unwrap(va());

        var settings = ko.unwrap(widget_model.settings_reader);
        var view = ko.unwrap(settings.view_name);
        var entity_name = ko.unwrap(settings.entity);
        var filters = ko.unwrap(settings.filters);
        var path = ko.unwrap(settings.path);
        var caption = ko.unwrap(settings.caption);

        //TODO: need to get the closest <page-ish> context
        var entity = ko.unwrap(uly.page.page_resource);
        var origin = entity ? entity.unique_id : null;

        widget_model.title("<h3 class='box-title'>{0}</h3>".format(_("userview_loading", "Loading...")));
        var view_res = uly.api.start().follow("uly:dataviews").follow("find", {
            rel: entity_name
        }).follow("find", {
            rel: view
        }, function (result) {
            console.log("looking for markup for view:", view, entity_name);
            var markup_q = view_res.follow("uly:markup", {
                "type": "html"
            });
            var data_q = view_res.follow("uly:results", {
                q: {
                    "origin": origin,
                    "path": path
                }
            });
            Promise.when(markup_q, data_q).then(function ([markup, data]) {
                $(elt).html(markup);
                widget_model.title('<h3 class="box-title">' + caption + '</h3>');
                var new_context = context.createChildContext(data.data);
                ko.applyBindingsToDescendants(new_context, elt);
                uly.publish("widget.active", elt);
            });
        });


        return;
    }
};
uly.widgets.register({
    "type": "userview",
    "caption": _("userview_caption_data_view", "Data View"),
    "description": _("userview_description_a_data_view_from_the_ulysses_system", "A data view from the Ulysses system"),
    "icon": "fa-tags",
    "init": initialise_dataview,
    "colour": "hippie-blue",
    "actions": [{
        "caption": _("userview_caption_settings", "Settings"),
        "icon": "fa-cog",
        "action": function (e) {
            return false;
        },
        "colour": "default"
    }]
});